import React from 'react';
import {
  ProductTransactionStatus,
  productTransactionStatusToColorClass,
  productTransactionStatusToLocalizedString,
} from '../../../types/productTransaction';
import StatusLabel from '../../../VentoryUI/components/common/StatusLabel/StatusLabel';

interface ProductTransactionStatusLabelProps {
  status: ProductTransactionStatus;
}

export default function ProductTransactionStatusLabel({ status }: ProductTransactionStatusLabelProps) {
  return (
    <StatusLabel
      color={productTransactionStatusToColorClass(status)}
      text={productTransactionStatusToLocalizedString(status)}
    />
  );
}
